import { useState } from "react";

export default function EditorNote() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  return (
    <section className="mx-auto max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
      <div className="overflow-hidden rounded-lg border border-stone-200 bg-stone-100 md:flex">
        {/* 编辑部观点 */}
        <div className="flex-1 p-6 md:p-8">
          <div className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-red-600">
            <i className="ri-edit-2-fill"></i> 编辑部追踪笔记
          </div>
          <h2 className="mt-3 font-serif text-xl font-black leading-snug tracking-tight text-stone-900 md:text-2xl">
            热搜登顶从来不是偶然，
            <br className="hidden sm:block" />
            它是路径被一步步走完的必然。
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-stone-600">
            当一条爆料开始被跨平台搬运，它的引爆时间线就已启动。暴走黑料帮你把这场全网扩散切成可视化的阶段——从病毒传播、评论区沦陷，到转发刷屏、热搜登顶。先看清路径，再判断话题走向。
          </p>
          <div className="mt-5 flex flex-wrap gap-3 text-xs text-stone-500">
            {["全网扩散追踪", "话题引爆路径", "热搜登顶观察"].map((k) => (
              <span key={k} className="inline-flex items-center gap-1 rounded border border-stone-300 bg-white px-2.5 py-1 font-medium">
                <i className="ri-price-tag-3-line text-red-500"></i> {k}
              </span>
            ))}
          </div>
        </div>

        {/* 追更订阅（静态交互演示，不连接任何服务） */}
        <div className="flex w-full flex-col justify-center border-stone-200 bg-stone-900 p-6 text-stone-100 md:w-[380px] md:border-l md:p-8">
          <div className="font-serif text-lg font-black text-white">订阅热搜登顶预警</div>
          <p className="mt-2 text-sm leading-6 text-stone-400">
            留下常用邮箱，话题进入引爆倒计时时第一时间收到追踪提醒。仅作演示，不会真实发送邮件。
          </p>
          {subscribed ? (
            <div className="mt-5 flex items-center gap-2 rounded-md border border-green-500/40 bg-green-500/10 px-4 py-3 text-sm font-semibold text-green-300">
              <i className="ri-checkbox-circle-line"></i> 已加入追更队列，感谢关注
            </div>
          ) : (
            <form
              className="mt-5"
              onSubmit={(e) => {
                e.preventDefault();
                if (email.trim()) setSubscribed(true);
              }}
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="输入常用邮箱"
                className="w-full rounded-md border border-stone-700 bg-stone-800 px-3 py-2.5 text-sm text-white placeholder:text-stone-500 outline-none focus:border-red-500"
              />
              <button
                type="submit"
                className="mt-3 w-full whitespace-nowrap rounded-md bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-500"
              >
                <i className="ri-notification-3-line mr-1"></i> 开启追更提醒
              </button>
              <p className="mt-2 text-[11px] leading-5 text-stone-500">
                提交即视为同意接收追踪通知，本页面为静态演示，不会产生真实数据提交。
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}